module.exports = __webpack_public_path__ + "img/whatsup.2ff847a4.png";